import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import PropTypes from 'prop-types';
import React from 'react';
import { sendClick } from 'reaxl-analytics';
import { ownerLocation } from 'reaxl-analytics-handlers';
import { Address, Button, Glyphicon, IconButton, LinkIcon } from 'reaxl';
function AddressLinkIcon(_ref) {
  let {
    map,
    uiContext,
    linkClassName,
    iconClassName,
    address = {},
    handleClick = () => {},
    ...restLocationProps
  } = _ref;
  const props = {
    className: linkClassName,
    placement: 'after',
    glyph: 'offsite',
    target: '_blank',
    rel: 'nofollow noopener',
    onClick: handleClick,
    undecorated: true,
    ...map,
    ...restLocationProps
  };
  if (uiContext === 'button') {
    props.glyph = 'directions';
    props.placement = 'none';
    props['aria-label'] = 'Directions';
    props.glyphClassName = iconClassName;
  }
  return /*#__PURE__*/React.createElement(LinkIcon, props, uiContext !== 'button' && /*#__PURE__*/_jsx(Address, {
    className: "display-inline",
    inline: true,
    location: address
  }));
}
function AddressButton(_ref2) {
  let {
    btnProps,
    map,
    handleClick,
    iconClassName
  } = _ref2;
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    target: "_blank",
    rel: "nofollow noopener",
    onClick: handleClick,
    "aria-label": "Directions"
  }, btnProps, map), /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "directions",
    className: iconClassName
  }));
}
const getAddress = _ref3 => {
  let {
    handleClick,
    location = {},
    uiContext = 'default',
    linkClassName,
    iconClassName,
    btnProps = {},
    isVirtual,
    distanceFromSearch
  } = _ref3;
  const {
    map,
    address,
    ...rest
  } = location;
  if (uiContext === 'button' && map) {
    return /*#__PURE__*/React.createElement(AddressButton, {
      map,
      btnProps,
      handleClick,
      iconClassName
    });
  }
  if (uiContext === 'default' && map && address) {
    return /*#__PURE__*/React.createElement(AddressLinkIcon, Object.assign({
      map,
      uiContext,
      linkClassName,
      address,
      handleClick
    }, rest));
  }
  if (address && (uiContext === 'unclickable' || !map && uiContext === 'default')) {
    return /*#__PURE__*/_jsx(Address, {
      inline: true,
      location: address
    });
  }
  if (uiContext === 'snapshot' && map && address) {
    const isDistanceViewable = !!distanceFromSearch && distanceFromSearch !== 0 && !isVirtual;
    return /*#__PURE__*/_jsx("div", {
      className: "display-flex text-center text-size-300"
    }, "distance_snapshot-container", _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
      glyph: "map-marker",
      className: "margin-right-3 text-size-500"
    }, "map-marker-icon")), /*#__PURE__*/_jsx("div", {
      className: "display-flex flex-column align-items-start text-wrap-pretty"
    }, "distance_address_text", /*#__PURE__*/React.createElement(AddressLinkIcon, Object.assign({
      key: "distance_address",
      map,
      uiContext,
      linkClassName,
      address,
      handleClick
    }, rest)), isDistanceViewable && /*#__PURE__*/_jsx("span", {
      className: "text-size-200 text-subdued-lighter"
    }, "distance_text", distanceFromSearch, ' ', "miles away")));
  }
  return null;
};
function OwnerAddress(_ref4) {
  let {
    wrapperComponent,
    wrapperProps = {},
    analyticsData,
    uiContext,
    isVirtual = false,
    distanceFromSearch,
    ...rest
  } = _ref4;
  const handleClick = event => sendClick(ownerLocation, event, analyticsData);

  // Short circuit complex component for simple icon button implementation
  if (uiContext === 'iconbutton') {
    const {
      location: {
        map
      } = {}
    } = rest;
    return map && /*#__PURE__*/React.createElement(IconButton, Object.assign({
      glyph: "directions",
      label: "Directions",
      layout: "stacked",
      onClick: handleClick,
      rel: "nofollow noopener",
      size: "large",
      target: "_blank"
    }, map));
  }
  const ownerAddress = getAddress({
    handleClick,
    uiContext,
    isVirtual,
    distanceFromSearch,
    ...rest
  });
  return ownerAddress && wrapperComponent ? /*#__PURE__*/React.createElement(wrapperComponent, wrapperProps, ownerAddress) : ownerAddress;
}
export default OwnerAddress;